export default __webpack_public_path__ + "gear.fe21f237.svg";